"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const components_1 = require("@/common/components");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const _1 = require(".");
exports.default = ({ expand }) => {
    (0, react_1.useEffect)(() => {
        const leaderTimeChange = Boolean((0, functions_1.getSearchParam)('change'));
        if (leaderTimeChange) {
            (0, functions_1.showToastMessage)({ message: `${t('작가님이 판매시간을 변경하셨어요')}:)` });
        }
    }, []);
    const isDemandSurvey = (0, react_redux_1.useSelector)((state) => state.isDemandSurvey);
    const whoAmI = (0, react_redux_1.useSelector)((state) => state.whoAmI);
    const goToLogin = () => (window.location.href = (0, string_utils_1.loginReturnPath)());
    const { t } = (0, react_i18next_1.useTranslation)();
    if (!whoAmI.ready)
        return (0, jsx_runtime_1.jsx)("div", { style: { width: '100%', height: '50px' } });
    if (!whoAmI.is_logged_in)
        return ((0, jsx_runtime_1.jsx)(components_1.MapleStoryButton, Object.assign({ onClick: goToLogin, isDemandSurvey: isDemandSurvey }, { children: t('로그인하기') })));
    return (0, jsx_runtime_1.jsx)(_1.CountdownButton, { expand: expand });
};
